'use client'
import {SkeletonTheme} from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import {lazy, Suspense, useEffect, useState} from "react";

const Toaster = lazy(() => import("@/shadcn/components/ui/sonner").then(mod => ({default: mod.Toaster})));
const CookieConsentComponent = lazy(() => import("@/components/cookie-consent/cookie-consent"));

export default function Providers({children}: { children: React.ReactNode }) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    return (
        <SkeletonTheme baseColor="#e5e7eb" highlightColor="#f3f4f6">
            {children}
            {mounted && (
                <Suspense fallback={null}>
                    <CookieConsentComponent/>
                    <Toaster toastOptions={{duration: 2000}} expand={false} closeButton position="top-right"/>
                </Suspense>
            )}
        </SkeletonTheme>
    )
}
